import { Deserializable } from '../protocols/deserializable';
import { BankAccount } from '../../views/banking/models/bank-account';
import { AnnualMinimumDetails } from '../transactions/annual-minimum-details';
import { LumpSumPaymentInstruction } from '../transactions/lump-sum-payment-instruction';
import { RecurringPaymentInstruction } from './recurring-payment-instruction';
import { WithdrawalInstruction } from './withdrawal-instruction';

export class VariableBenefitPaymentChangeSubmissionData implements Deserializable {
  public forgoRecurringPayments!: boolean;
  public bankAccountId!: number | null;
  public bankAccount!: BankAccount | null;
  public annualMinimumDetails!: AnnualMinimumDetails;
  public lumpSumPaymentInstruction!: LumpSumPaymentInstruction | null;
  public activeMonthlyRecurringPaymentInstruction!: RecurringPaymentInstruction | null;
  public activeAnnualRecurringPaymentInstruction!: RecurringPaymentInstruction | null;
  public scheduledMonthlyRecurringPaymentInstruction!: RecurringPaymentInstruction | null;
  public scheduledAnnualRecurringPaymentInstruction!: RecurringPaymentInstruction | null;
  public withdrawalInstructions!: WithdrawalInstruction[];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.bankAccount) {
      this.bankAccount = Deserialize.instanceOf(BankAccount, this.bankAccount);
    }

    if (this.annualMinimumDetails) {
      this.annualMinimumDetails = Deserialize.instanceOf(AnnualMinimumDetails, this.annualMinimumDetails);
    }

    if (this.lumpSumPaymentInstruction) {
      this.lumpSumPaymentInstruction = Deserialize.instanceOf(
        LumpSumPaymentInstruction,
        this.lumpSumPaymentInstruction
      );
    }

    if (this.activeMonthlyRecurringPaymentInstruction) {
      this.activeMonthlyRecurringPaymentInstruction = Deserialize.instanceOf(
        RecurringPaymentInstruction,
        this.activeMonthlyRecurringPaymentInstruction
      );
    }

    if (this.activeAnnualRecurringPaymentInstruction) {
      this.activeAnnualRecurringPaymentInstruction = Deserialize.instanceOf(
        RecurringPaymentInstruction,
        this.activeAnnualRecurringPaymentInstruction
      );
    }

    if (this.scheduledMonthlyRecurringPaymentInstruction) {
      this.scheduledMonthlyRecurringPaymentInstruction = Deserialize.instanceOf(
        RecurringPaymentInstruction,
        this.scheduledMonthlyRecurringPaymentInstruction
      );
    }

    if (this.scheduledAnnualRecurringPaymentInstruction) {
      this.scheduledAnnualRecurringPaymentInstruction = Deserialize.instanceOf(
        RecurringPaymentInstruction,
        this.scheduledAnnualRecurringPaymentInstruction
      );
    }

    if (this.withdrawalInstructions) {
      this.withdrawalInstructions = this.withdrawalInstructions.map(instruction =>
        Deserialize.instanceOf(WithdrawalInstruction, instruction)
      );
    }
  }
}
